import { Link } from "react-router-dom";
import CyberpunkTunnel from "../../../components/feature/CyberpunkTunnel";

export default function HeroSection() {
  return (
    <section className="relative h-screen min-h-[720px] w-full overflow-hidden bg-[#01010a] text-white">
      <CyberpunkTunnel
        params={{
          lightIntensity: 1.4,
          bloomStrength: 1.5,
          bloomRadius: 0.5,
          bloomThreshold: 0.1,
          reflectionStrength: 0.45,
          ghostIntensity: 1.2,
          matrixIntensity: 0.3,
        }}
      />

      {/* dark vignette overlay for legibility */}
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_center,_transparent_30%,_rgba(0,0,0,0.55)_75%,_rgba(0,0,0,0.85)_100%)]" />
      {/* scanlines */}
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.18] mix-blend-overlay"
        style={{
          backgroundImage:
            "repeating-linear-gradient(to bottom, rgba(255,255,255,0.08) 0px, rgba(255,255,255,0.08) 1px, transparent 1px, transparent 3px)",
        }}
      />

      {/* corner brackets */}
      <div className="pointer-events-none absolute left-6 top-24 z-10 hidden md:block">
        <div className="text-[10px] tracking-[0.35em] text-[#e8b93a]/80">
          /// 科普出版 · GIYAO
        </div>
        <div className="mt-2 h-12 w-px bg-gradient-to-b from-[#e8b93a]/80 to-transparent" />
      </div>
      <div className="pointer-events-none absolute right-6 top-24 z-10 hidden text-right md:block">
        <div className="text-[10px] tracking-[0.35em] text-[#9e5cff]/80">
          知識探索 // SIGNAL
        </div>
        <div className="mt-2 ml-auto h-12 w-px bg-gradient-to-b from-[#9e5cff]/80 to-transparent" />
      </div>

      {/* main content */}
      <div className="relative z-10 flex h-full w-full flex-col items-center justify-center px-6 text-center">
        {/* badge */}
        <div className="mb-7 inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/[0.04] px-4 py-1.5 text-xs text-white/70 backdrop-blur-sm">
          <span className="h-1.5 w-1.5 rounded-full bg-[#9e5cff] shadow-[0_0_8px_rgba(158,92,255,0.9)]" />
          <span className="tracking-wide">科普類書籍</span>
        </div>

        {/* brand name */}
        <h1
          className="max-w-5xl text-5xl leading-[1.05] tracking-tight text-white md:text-7xl lg:text-[88px]"
          style={{ fontFamily: "'Noto Sans TC', sans-serif", fontWeight: 700 }}
        >
          機曜文化
        </h1>

        {/* english name */}
        <p className="mt-3 text-xl tracking-[0.35em] text-[#e8b93a]/90 md:text-2xl">
          GIYAO
        </p>

        {/* tagline */}
        <p className="mt-8 max-w-2xl text-lg leading-relaxed text-white/80 md:text-xl">
          從閱讀出發，探索值得理解的內容
        </p>

        {/* summary */}
        <p className="mt-4 max-w-2xl text-sm leading-relaxed text-white/55 md:text-base">
          機曜文化以科普類書籍為主要出版方向，透過適合一般讀者理解的文字與圖像，呈現自然科學、人體、環境、科技及知識探索等主題。
        </p>

        {/* CTAs */}
        <div className="mt-10 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/about"
            className="flex items-center gap-2 whitespace-nowrap rounded-full bg-white px-8 py-3.5 text-sm font-medium text-black transition hover:bg-white/90 cursor-pointer"
          >
            認識機曜文化
          </Link>
          <a
            href="https://catalog.sonbook.net/"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="flex items-center gap-2 whitespace-nowrap rounded-full border border-white/30 px-8 py-3.5 text-sm font-medium text-white/85 transition hover:border-white/60 hover:text-white cursor-pointer"
          >
            查詢完整書目
            <i className="ri-arrow-right-up-line text-xs" />
          </a>
        </div>

        {/* bottom info */}
        <div className="mt-12 flex items-center justify-center gap-3 text-xs text-white/50">
          <span className="font-medium text-white/60">本品牌委託崧博出版經銷</span>
          <span className="text-white/30">·</span>
          <a
            href="https://sonbook.net/"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="underline underline-offset-2 transition hover:text-[#e8b93a]"
          >
            sonbook.net
          </a>
        </div>
      </div>

      {/* scroll cue */}
      <div className="pointer-events-none absolute bottom-6 left-1/2 z-10 -translate-x-1/2 text-center">
        <div className="text-[10px] tracking-[0.5em] text-white/50">SCROLL</div>
        <div className="mx-auto mt-2 h-8 w-px animate-pulse bg-gradient-to-b from-white/80 to-transparent" />
      </div>
    </section>
  );
}